export interface IDetailsResponse {
  response: Response;
}

export const GetDummyResponse: () => Response = () => {
  return new Response();
};
